import React from 'react';

/**
 * PiSidebarLeftCloseStroke icon from the stroke style in arrows-&-navigation category.
 */
interface PiSidebarLeftCloseStrokeProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiSidebarLeftCloseStroke({
  size = 24,
  color,
  className,
  ariaLabel = 'sidebar-left-close icon',
  ...props
}: PiSidebarLeftCloseStrokeProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor" strokeWidth="1.39" strokeLinecap="round" strokeLinejoin="round" style={{color: color || "currentColor"}}
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.39" d="M6 2.00736C4.97385 2.02701 4.33865 2.09906 3.82003 2.36331C3.19282 2.68289 2.68289 3.19282 2.36331 3.82003C2 4.53307 2 5.46649 2 7.33333V8.66667C2 10.5335 2 11.4669 2.36331 12.18C2.68289 12.8072 3.19282 13.3171 3.82003 13.6367C4.33865 13.9009 4.97385 13.973 6 13.9926C6.38468 14 6.82431 14 7.33333 14H8.66667C10.5335 14 11.4669 14 12.18 13.6367C12.8072 13.3171 13.3171 12.8072 13.6367 12.18C14 11.4669 14 10.5335 14 8.66667V7.33333C14 5.46649 14 4.53307 13.6367 3.82003C13.3171 3.19282 12.8072 2.68289 12.18 2.36331C11.4669 2 10.5335 2 8.66667 2H7.33333C6.82431 2 6.38468 2 6 2.00736ZM6 13.9926L6 2.00736M11 6C10.2691 6.53103 9.61436 7.15354 9.0529 7.85106C8.98237 7.93869 8.98237 8.06132 9.0529 8.14894C9.61436 8.84646 10.2691 9.46897 11 10" fill="none"/>
    </svg>
  );
}
